import axios from './axios';
import SETTINGS from '../settings'
export default {
  getEngagements(cb) {
    axios.get(`${SETTINGS.API_BASE_PATH}/engagement?_embed=1`, ).then(response => {
      cb(response.data)
    }).catch(e => {
      console.log(e)
    })
  },
  getEngagementProject(params, cb) {
    axios.get(`${SETTINGS.API_BASE_PATH}/engagementproject`, {params} ).then(response => {
      cb(response.data)
    }).catch(e => {
      console.log(e)
    })
  },
  getEngagementKeyFact(params, cb) {
    axios.get(`${SETTINGS.API_BASE_PATH}/engagementkeyfact`, {params} ).then(response => {
      cb(response.data)
    }).catch(e => {
      console.log(e)
    })
  }
}